export default {
  dark: 'Sombre',
  light: 'Clair',
};
